import { useState } from 'react';
import MovieCard from '@/components/feature/MovieCard';
import Pagination from '@/components/base/Pagination';
import EmptyState from '@/components/base/EmptyState';
import { movies } from '@/mocks/movies';
import { sortMovies } from '@/lib/movies';

const PAGE_SIZE = 8;

export default function LatestSection() {
  const [page, setPage] = useState(1);
  const sorted = sortMovies(movies, 'updated');
  const total = Math.ceil(sorted.length / PAGE_SIZE);
  const list = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handlePage = (next: number) => {
    setPage(next);
    const el = document.getElementById('latest');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="latest" className="w-full bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新上线影视</h2>
            <p className="mt-1 text-sm text-foreground-600">按更新时间排序，第一时间掌握新内容</p>
          </div>
          <span className="hidden shrink-0 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 sm:block">
            共 {sorted.length} 部 · 演示数据
          </span>
        </div>

        {list.length === 0 ? (
          <EmptyState
            icon="ri-movie-line"
            title="暂无影视内容"
            description="当前列表为空，请尝试刷新页面或稍后再来看看。"
          />
        ) : (
          <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
            {list.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        )}

        <Pagination current={page} total={total} onChange={handlePage} />
      </div>
    </section>
  );
}